function openProductContactModal(productName) {
    setTimeout(function (args) {

        var text = 'Salve, volevo acquistare il prodotto "'+productName+'"';
        if (locale == 'en') {
            text = 'Hi, I want to buy the product "'+productName+'"';
        }

        $('#contacts-form').find('#contact_message').text(text);
        $('#contacts-form').find('#contact_product').val(productName);
    }, 500);
    MicroModal.show('product-form-modal');
}

function loadRecaptchaContacts(form) {
    grecaptcha.ready(function() {
        grecaptcha.execute(recaptchaKey,
            { action: 'contact' }).then(function (token) {
            var recaptchaResponse = document.getElementById('contact_recaptcha');
            recaptchaResponse.value = token;

            $.post('/contacts/send', form.serializeArray(), function(data) {
                $('#contact-wrapper').html(data.html);
                setTimeout(function () {
                    initFormContacts();
                }, 250);
                if (data.result) {
                    if(document.getElementById("product-form-modal")) {
                        MicroModal.close('product-form-modal');
                    }
                    MicroModal.show('contacts-form-modal');
                    window.dataLayer =  window.dataLayer || [];
                    dataLayer.push({
                        'event': 'submit',
                        'form_submitted': 'contacts'
                    });
                    // fbq_trackCustom('submit__contacts');
                }
            });
        });
    });
}

var submitHandlerContacts = function(e) {
    e.preventDefault();
    e.target.removeEventListener('submit', submitHandlerContacts, false);

    document.getElementById('contacts-form-submit').classList.add('d-none');
    document.getElementById('contacts-form-loader').classList.remove('d-none');

    var form = $(this);
console.log({
    submitElement: document.getElementById("contacts-form-submit"),
    form: {
        selector: document.getElementById("contacts-form"),
        map: {
            subject: {
                first_name: form.find('#contact_name').val(),
                last_name: form.find('#contact_surname').val(),
                email: form.find('#contact_email').val()
            },
            preferences: {
                generic: "generic"
            }
        }
    },
    consent: {
        legal_notices: [
            {
                identifier: "privacy_policy",
            },
            {
                identifier: 'cookie_policy',
            },
            {
                identifier: "terms",
            }
        ],
    }
});
    _iub.cons_instructions.push(["load", {
        submitElement: document.getElementById("contacts-form-submit"),
        form: {
            selector: document.getElementById("contacts-form"),
            map: {
                subject: {
                    first_name: form.find('contact[name]').val(),
                    last_name: form.find('contact[surname]').val(),
                    email: form.find('contact[email]').val()
                },
                preferences: {
                    generic: "generic"
                }
            }
        },
        consent: {
            legal_notices: [
                {
                    identifier: "privacy_policy",
                },
                {
                    identifier: 'cookie_policy',
                },
                {
                    identifier: "terms",
                }
            ],
        }
    }])

    loadRecaptchaContacts(form);
};

function initFormContacts() {
    document.getElementById('contacts-form').addEventListener("submit", submitHandlerContacts);
}
initFormContacts();
